"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Toaster = _interopRequireDefault(require("./Toaster"));

var toaster = new _Toaster.default();
var _default = toaster;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy90b2FzdGVyL3NyYy9pbmRleC5qcyJdLCJuYW1lcyI6WyJ0b2FzdGVyIiwiVG9hc3RlciJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUE7O0FBRUEsSUFBTUEsT0FBTyxHQUFHLElBQUlDLGdCQUFKLEVBQWhCO2VBRWVELE8iLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgVG9hc3RlciBmcm9tICcuL1RvYXN0ZXInXG5cbmNvbnN0IHRvYXN0ZXIgPSBuZXcgVG9hc3RlcigpXG5cbmV4cG9ydCBkZWZhdWx0IHRvYXN0ZXJcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/toaster/src/index.js
// module id = 265
// module chunks = 0